import { CardSection } from "./common/Card";
import { useState } from "react";
import {Alert} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import {DownloadCSVButton} from "./common/SubmitButton";
import { Result } from "../client/Result";
import {Select, SelectOption} from "./common/MuiSelect";


interface EMRComponentReportProps {
    download: (cmuId: string) => Promise<Result<void>>
    className?: string
    cmuIds: string[]
    cardTitle: string;
    dataTestPrefix: string;
}

export const EMRComponentReport = ({ download, className, cmuIds, cardTitle, dataTestPrefix }: EMRComponentReportProps) => {
    const [cmu, setCmu] = useState('')
    const [validated, setValidated] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string>()

    async function handleSubmit(event) {
        const form = event.currentTarget
        setErrorMessage(undefined)
        event.preventDefault()
        setValidated(true)
        if (form.checkValidity() === true) {
            const submissionResult = await download(cmu)
            submissionResult.fold(
                ()  => undefined,
                err => setErrorMessage(`An error occurred - #ask-tech for support. ${err}`)
            )
        } else {
            form.reportValidity()
        }
    }

    return <CardSection className={className} header={cardTitle} as="h6">
        <Form noValidate validated={validated} >
            <Select className='mb-3' label='CmuId' data-testid={`${dataTestPrefix}_cmu`} initialValue={{ id: cmu, label: cmu}}
                    onChange={(e:SelectOption) => {
                        setErrorMessage(undefined)
                        setCmu(e.id)
                    }}
                    options={cmuIds.map(b => ({ id: b, label: b}))} />

            <DownloadCSVButton dataTestId={`${dataTestPrefix}_download`} disabled={!cmu} onSubmit={handleSubmit}/>
            {errorMessage &&
                <Alert data-testid='errorMessage' variant='danger'>{errorMessage}</Alert>}
        </Form>
    </CardSection>
}
